<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">


            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('优惠券')" prop="couponCode">
                <a-input v-model="queryParam.couponTypeName" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('优惠券')" allow-clear/>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item label="优惠券状态">
                <a-select v-model="queryParam.state" placeholder="请选择状态" allow-clear @change="handleQuery">
                  <a-select-option :value="1">已领取</a-select-option>
                  <a-select-option :value="2">已使用</a-select-option>
                  <a-select-option :value="3">已过期</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item label="领取人">
                <a-input v-model="queryParam.userName" :maxLength="32" placeholder="昵称/手机号" allow-clear @keyup.enter="handleQuery"/>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="领取时间">
                <a-range-picker
                  v-model="fetchDateRange"
                  :placeholder="['开始时间', '结束时间']"
                  style="width: 100%"
                  @change="handleQuery"
                />
              </a-form-item>
            </a-col>

            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
<!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['coupon:couponreceive:add']">-->
<!--          <a-icon type="plus" />{{$t('通用.按钮.新增')}}-->
<!--        </a-button>-->
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['coupon:couponreceive:edit']">-->
<!--          <a-icon type="edit" />{{$t('通用.按钮.修改')}}-->
<!--        </a-button>-->
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['coupon:couponreceive:remove']">
          <a-icon type="delete" />{{$t('通用.按钮.删除')}}
        </a-button>
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['coupon:couponreceive:export']">-->
<!--          <a-icon type="download" />{{$t('通用.按钮.导出')}}-->
<!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="fetchTime" slot-scope="text, record">
          {{ parseTime(record.fetchTime) }}
        </span>
        <span slot="useTime" slot-scope="text, record">
          {{ parseTime(record.useTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
<!--          <a-divider type="vertical" v-hasPermi="['coupon:coupon/receive:edit']" />-->
<!--          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['coupon:coupon/receive:edit']">-->
<!--             <a-icon type="edit" />{{$t('通用.按钮.修改')}}-->
<!--          </a>-->
          <a-divider type="vertical" v-hasPermi="['coupon:couponreceive:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['coupon:couponreceive:remove']">
            <a-icon type="delete" />{{$t('通用.按钮.删除')}}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageCouponReceive,listCouponReceive, delCouponReceive } from '@/api/coupon/couponReceive'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'CouponReceive',
  components: {
    CustomDictTag,
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        couponTypeId: undefined,
        shopId: undefined,
        couponTypeName: undefined,
        userId: undefined,
        useOrderId: undefined,
        createOrderId: undefined,
        money: undefined,
        detailMessage: undefined,
        rangeGoodsId: undefined,
        atLeast: undefined,
        fetchTime: undefined,
        useTime: undefined,
        state: undefined,
        startTime: undefined,
        endTime: undefined,
        fetchBeginTime: undefined,
        fetchEndTime: undefined,
        userName: undefined,
        getType: undefined,
        isNewCoupon: undefined,
        needPop: undefined,
        pupNum: undefined,
        pageNum: 1,
        pageSize: 10
      },
      // 领用时间范围选择器值（moment 数组）
      fetchDateRange: [],
      columns: [

        {
          title: this.$t('优惠券'),
          dataIndex: 'couponName',
          ellipsis: true,
          align: 'center'
        },

        {
          title: this.$t('领取人'),
          dataIndex: 'nickName',
          ellipsis: true,
          align: 'center'
        },

        {
          title: this.$t('面额'),
          dataIndex: 'money',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('领取时间'),
          dataIndex: 'fetchTime',
          scopedSlots: { customRender: 'fetchTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('使用时间'),
          dataIndex: 'useTime',
          scopedSlots: { customRender: 'useTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('优惠券状态'),
          dataIndex: 'state',
          ellipsis: true,
          align: 'center',
          customRender: function (v) {
            if (v == 1) {
              return "已领取";
            }else if (v == 2){
              return '已使用';
            }else if (v == 3){
              return '已过期';
            }
          }
        },

        // {
        //   title: this.$t('获取方式1领取2.兑换'),
        //   dataIndex: 'getType',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: this.$t('优惠券类型'),
          dataIndex: 'isNewCoupon',
          ellipsis: true,
          align: 'center',
          customRender: function (v) {
            if (v == 0) {
              return "普通优惠券";
            }else if (v == 1){
              return '新人优惠券';
            } else if (v == 2){
              return '直播优惠券';
            }else if (v == 3){
              return '礼品券';
            }
          }
        },

        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('通用.文本.共')+total+this.$t('通用.文本.条')
    },
    /** 查询优惠券-用户关联列表 */
    getList () {
      this.loading = true
     pageCouponReceive(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      // 将领用时间范围拆成起止时间传给后端
      if (this.fetchDateRange && this.fetchDateRange.length === 2) {
        this.queryParam.fetchBeginTime = this.fetchDateRange[0].format('YYYY-MM-DD 00:00:00')
        this.queryParam.fetchEndTime = this.fetchDateRange[1].format('YYYY-MM-DD 23:59:59')
      } else {
        this.queryParam.fetchBeginTime = undefined
        this.queryParam.fetchEndTime = undefined
      }
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.fetchDateRange = []
      this.queryParam = {
        couponTypeId: undefined,
        shopId: undefined,
        couponTypeName: undefined,
        userId: undefined,
        useOrderId: undefined,
        createOrderId: undefined,
        money: undefined,
        detailMessage: undefined,
        rangeGoodsId: undefined,
        atLeast: undefined,
        fetchTime: undefined,
        useTime: undefined,
        state: undefined,
        startTime: undefined,
        endTime: undefined,
        fetchBeginTime: undefined,
        fetchEndTime: undefined,
        userName: undefined,
        getType: undefined,
        isNewCoupon: undefined,
        needPop: undefined,
        pupNum: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delCouponReceive(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('通用.文本.删除成功')
              that.$message.success(
                message,
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('通用.文本.是否确认导出'),
        content: this.$t('通用.文本.此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('coupon/coupon/receive/export',
            ...that.queryParam
          , `优惠券-用户关联_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
